//Wait for ms 
const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default delay;